module.exports = __webpack_public_path__ + "img/avator.b313993f.png";